import { render, staticRenderFns } from "./versionRecord.vue?vue&type=template&id=729e4767&scoped=true"
import script from "./versionRecord.vue?vue&type=script&lang=js"
export * from "./versionRecord.vue?vue&type=script&lang=js"
import style0 from "./versionRecord.vue?vue&type=style&index=0&id=729e4767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729e4767",
  null
  
)

export default component.exports